import "core-js/modules/es.array.concat.js";
export var timeSince = function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);
  var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    return "hace ".concat(interval, " ").concat(interval === 1 ? 'año' : 'años');
  }
  interval = Math.floor(seconds / 2592000);
  if (interval >= 1) {
    return "hace ".concat(interval, " ").concat(interval === 1 ? 'mes' : 'meses');
  }
  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    return "hace ".concat(interval, " ").concat(interval === 1 ? 'día' : 'días');
  }
  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    return "hace ".concat(interval, " ").concat(interval === 1 ? 'hora' : 'horas');
  }
  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return "hace ".concat(interval, " ").concat(interval === 1 ? 'minuto' : 'minutos');
  }
  return 'ahora mismo';
};